var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('PDFHeader',{attrs:{"title":this.title,"event-bus":this.eventBus,"num-pages":this.numPages},on:{"setPage":_vm.setPage,"zoomIn":_vm.zoomIn,"zoomOut":_vm.zoomOut}}),_vm._m(0),_c('Spinner',{attrs:{"show":this.showSpinner}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"viewerContainer"}},[_c('div',{staticClass:"pdfViewer",attrs:{"id":"viewer"}})])
}]

export { render, staticRenderFns }